import { GlobalStyles } from '@mui/material'
import { useAuth } from 'ply-auth/provider'
import { ConfigClient, ConfigProvider } from 'ply-config'
import { retry } from 'ply-utils'
import Loading from 'ply-ux/Loading'
import { PromptProvider } from 'ply-ux/Prompt'
import { TasksProvider, TaskType } from 'ply-ux/Tasks'
import { BatchTask } from 'ply-ux/Tasks/BatchTask'
import * as React from 'react'
import adapters from './services'

const APP_STATE_KEY = 'app_state'
export const appStateManager = {
	getter: () => sessionStorage.getItem(APP_STATE_KEY),
	setter: (value: string) => sessionStorage.setItem(APP_STATE_KEY, value),
	remove: () => sessionStorage.removeItem(APP_STATE_KEY),
}

const configClient = new ConfigClient({
	baseUrl: '/api',
	adapters,
})

const styles = {
	'input[type="number"]': {
		appearance: 'textfield',
	},
	'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
		appearance: 'none',
	},
}

// const Unauthorized = React.lazy(() => retry(() => import('./Unauthorized')))

const Staff = React.lazy(() => retry(() => import('./Staff')))

export default function Root() {
	const {
		user: { loggedIn, tried },
		getAuthorizationUrl,
	} = useAuth((s) => s)

	if (!tried) {
		return null
	}

	if (!loggedIn) {
		//
		appStateManager.setter(window.location.hash)

		getAuthorizationUrl().then((url) => {
			window.location.assign(url)
		})

		return <Loading />
	}

	// if (!loggedIn) {
	//     return (
	//         <>
	//             <GlobalStyles styles={styles} />
	//             <React.Suspense fallback={<Loading />}>
	//                 <Unauthorized />
	//             </React.Suspense>
	//         </>
	//     )
	// }

	return (
		<>
			<GlobalStyles styles={styles} />
			<React.Suspense fallback={<Loading />}>
				<ConfigProvider client={configClient}>
					<TasksProvider>
						<TaskType name="test" element={BatchTask} />

						<PromptProvider>
							<Staff />
						</PromptProvider>
					</TasksProvider>
				</ConfigProvider>
			</React.Suspense>
		</>
	)
}
//
